import React from 'react';

interface FormLayoutProps {
  children: React.ReactNode;
  maxWidthClass?: string;
}

const FormLayout: React.FC<FormLayoutProps> = ({ children, maxWidthClass = 'max-w-lg' }) => {
  return (
    <div className="min-h-screen flex flex-col bg-dark-950">
      {/* Main Content */}
      <div className="flex-1 flex items-start mt-16 md:mt-20 justify-center">
        <div className={`w-full ${maxWidthClass} mx-auto px-4`}>
          {/* Auth Form Container */}
          <div className="bg-black/50 backdrop-blur-sm rounded-3xl p-10 shadow-xl border border-gray-700/30">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormLayout;
